export const addresses = {
  font: "0xDDa0648FA8c9cD593416EC37089C2a2E6060B45c",
};
